module.exports = __webpack_public_path__ + "static/media/CompetitionSciExamBigIcon.ed511d2c.svg";